import { useContext, useEffect, useState } from "react"
import utility from "src/utils/utility"
import { useNavigate, useParams } from "react-router-dom"
// import {  GridContainer } from "src/style"
import ApiContext from "src/provider/API/call-service"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { InstitutionData } from "src/model"
// import helpers from "src/utils/helpers"
// import { NotFound } from "src/component"
// import Lottie from "lottie-react";
// import loaderGif from "src/assets/gif/loader.json";

const LandingScreen: React.FC = () => {
    const navigate = useNavigate()
    const { alias } = useParams()
    //const {API} = useContext(ApiContext)
    const {setInfoProperty, logout} = useContext(AppInfoContext)
   // const [institutionData, setInstitutionData] = useState<InstitutionData | unknown>({})

    

    useEffect(() => {
        handleAlias()
    }, [])

    async function handleAlias() {
        // For checking if the existing alias is same as new alias
        const savedAlias = await localStorage.getItem('alias')
        if (savedAlias && savedAlias != alias) await logout()

        await setInfoProperty('alias', alias)
        navigate('/login')
    }

    {/* <AppSpan textSize='7' color='rgba(0, 0, 0, 0.5)' className='fa fa-spinner fa-spin' /> */}

    return (
        <>
            {/* { institutionData ?
                <GridContainer 
                    height="100" hUnit="%" padding='2.5'
                    bgColor='rgba(0, 0, 0, 0.05)'
                    style={{overflow: 'hidden', backdropFilter: 'blur(2.5px)'}}
                >
                    <GridContainer width="20" sizeUnit="">
                        <Lottie animationData={loaderGif} loop={true} />
                    </GridContainer>
                    
                </GridContainer>
                : <NotFound/>
            } */}
        </>
    )
}

export default utility.routeData(':alias', 'Landing Screen', <LandingScreen/>)